import { NavLink } from "react-router-dom";
import { Archive, FileKey, Gauge, KeyRound, ListChecks, UserCircle, Users } from "lucide-react";
import { cn } from "@/lib/utils";

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  end?: boolean;
}

const primary: NavItem[] = [
  { to: "/", label: "Dashboard", icon: Gauge, end: true },
  { to: "/users", label: "Users", icon: UserCircle },
  { to: "/subscribers", label: "Subscribers", icon: Users },
  { to: "/andes-queue", label: "Andes queue", icon: ListChecks },
];

const utilities: NavItem[] = [
  { to: "/utilities/csr", label: "CSR", icon: KeyRound },
  { to: "/utilities/pfx", label: "PFX", icon: FileKey },
  { to: "/utilities/p12", label: "P12", icon: Archive },
];

function Item({ to, label, icon: Icon, end }: NavItem) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          "flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors",
          isActive
            ? "bg-brand-50 text-brand-700 font-medium"
            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        )
      }
    >
      <Icon className="h-4 w-4" />
      {label}
    </NavLink>
  );
}

export function Sidebar() {
  return (
    <aside className="w-56 shrink-0 border-r border-slate-200 bg-white px-3 py-4 flex flex-col gap-6">
      <div>
        <p className="px-3 pb-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
          Main
        </p>
        <nav className="space-y-0.5">
          {primary.map((item) => (
            <Item key={item.to} {...item} />
          ))}
        </nav>
      </div>
      <div>
        <p className="px-3 pb-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
          Utilities
        </p>
        <nav className="space-y-0.5">
          {utilities.map((item) => (
            <Item key={item.to} {...item} />
          ))}
        </nav>
      </div>
      <div className="mt-auto px-3 text-[11px] text-slate-400">
        <p>API base</p>
        <p className="font-mono break-all text-slate-500">
          {import.meta.env.VITE_API_URL ?? "/api proxy → :8602"}
        </p>
      </div>
    </aside>
  );
}
